import React, { useState, useEffect } from 'react';
import { CardComponentProps } from '@/lib/cards';
import { getApiVersion } from '@/api/user';

/**
 * Version Card
 * Displays application version information
 */
export const VersionCard: React.FC<CardComponentProps> = ({
  card,
  userContext,
  onError,
}) => {
  const [apiVersion, setApiVersion] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const spaVersion = import.meta.env.VITE_APP_VERSION || 'dev';

  useEffect(() => {
    async function loadData() {
      try {
        setLoading(true);
        const result = await getApiVersion();
        setApiVersion(result.version);
      } catch (err) {
        onError?.(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, [onError]);

  if (loading) {
    return <div style={{ padding: '1rem', color: '#666' }}>Loading version information...</div>;
  }

  return (
    <div style={{ padding: '1rem' }}>
      <div style={{ marginBottom: '1rem' }}>
        <div style={{ marginBottom: '0.75rem', paddingBottom: '0.75rem', borderBottom: '1px solid #eee' }}>
          <strong>SPA Version:</strong>
          <br />
          <code
            style={{
              display: 'inline-block',
              marginTop: '0.25rem',
              padding: '0.25rem 0.5rem',
              backgroundColor: '#f5f5f5',
              borderRadius: '3px',
              fontFamily: 'monospace',
              fontSize: '0.9rem',
            }}
          >
            {spaVersion}
          </code>
        </div>

        <div style={{ paddingBottom: '0.75rem', borderBottom: '1px solid #eee' }}>
          <strong>API Version:</strong>
          <br />
          <code
            style={{
              display: 'inline-block',
              marginTop: '0.25rem',
              padding: '0.25rem 0.5rem',
              backgroundColor: '#f5f5f5',
              borderRadius: '3px',
              fontFamily: 'monospace',
              fontSize: '0.9rem',
            }}
          >
            {apiVersion ?? '—'}
          </code>
        </div>
      </div>
    </div>
  );
};

VersionCard.displayName = 'VersionCard';

export default VersionCard;
